<template>
	<nk-multichoice2 v-model="selecteds" @update:modelValue="valueChanged" :data="dropdownData" :options="componentOptions" :tabindex="tabindex" ref="multichoice"></nk-multichoice2>
</template>
<script>
	import _ from 'lodash'
	import $ from 'jquery'
	import { mapGetters, mapActions } from 'vuex'
	import emptyId from '~/statics/empty-id'
	import Endpoints from '@nikan/endpoints'
	import FloatingCenterAdvanceName from '~/components/form/floating-center-advance-name'
	import $sc from '~/plugins/shortcut.collection.js'
	import CenterList from '~/views/floating-centers/center-selector.vue'

	export default {
		props: {
			modelValue: {},
			options: {},
			tabindex: { default: 0 },
			level: { default: 0 },
		},
		emits: ['update:modelValue', 'dataChanged'],
		data() {
			return {
				settings: {
					baseUrl: Endpoints.getUrl('floatingCenters.search'),
					baseAccountId: 0,
					cleanOnMount: true,
					editable: true,
					filter: {},
					display: (item) => {
						if (item != null) {
							return item.name
						}
						return ''
					},
					readOnlyDisplay: (item) => {
						if (item != null) {
							return item.name
						}
						return ''
					},
					searchRequestFilter: (items, request) => {
						var ids = []
						if (items && items.length > 0) {
							for (var i = 0; i < items.length; i++) {
								ids.tryPush(items[i].position)
							}

							request.exceptPositions = ids
							request.relatedAccountId = this.baseAccountsArray[0]
						}
						return request
					},
					dropdown: {}
				},
				centersList: [],
				ready: false,
				selecteds: []
			}
		},
		computed: {
			...mapGetters({
				findForm: 'forms/findFormByKey',
				getAutoAccountsItemsByKey: 'autoAccounts/getItemsByKey',
				getCentersByAccountId: 'floatingCenters/getCentersByAccountId',
				getAllCenters: 'floatingCenters/all',
				getAllAccounts: 'accounts/all',
				isServerSide: 'floatingCenters/isServerSide',
			}),
			componentOptions() {
				var sett = _.cloneDeep(this.settings)

				var url = sett.baseUrl

				sett.dropdown.url = url

				if (!sett.editable) {
					sett.display = sett.readOnlyDisplay
				}

				return sett
			},
			dropdownData() {
				let result = _.cloneDeep(this.centersList)

				result = result.filter(x => x.hasChild === false)

				this.$emit('dataChanged', result)
				return result
			},
			baseAccountsArray() {
				if (this.settings.formName && this.findForm(this.settings.formName)) {
					let keys = this.findForm(this.settings.formName)
						.types
						.reduce((arr, item) => {
							arr.push(item.key)
							return arr
						}, [])
					this.settings.baseAccountId = this.findAccountsByAutoKey(keys)
				}
				if (!this.settings.baseAccountId) {
					return []
				} else if (Array.isArray(this.settings.baseAccountId)) {
					return this.settings.baseAccountId
				} else if (this.settings.baseAccountId > emptyId) {
					return [this.settings.baseAccountId]
				} else {
					return []
				}
			},
			factorType() {
				return this.settings.factorType || ''
			},
			serverSideStatus() {
				return (this.baseAccountsArray.length > 3 || this.isServerSide) && !(this.data && this.data.length)
			},
		},
		watch: {
			options: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings = _.merge({}, this.settings, val)
					this.prepareCentersList()
				}
			},
			level: {
				immediate: true,
				deep: true,
				handler(val) {
					this.settings.centerLevel = val
					this.prepareCentersList()
				}
			},
			getAllCenters: {
				deep: true,
				handler() {
					if (this.serverSideStatus) return

					this.prepareCentersList()
				}
			},
			centersList: {
				handler() {
					this.cleanValue()
				}
			},
			modelValue: {
				immediate: true,
				deep: true,
				handler(val) {
					this.selecteds = val
				}
			},
		},
		created() {
			this.setComponentSettings()
		},
		mounted() {
			if (this.settings.cleanOnMount)
				this.cleanValue()

			if (this.level)
				this.settings.centerLevel = this.level
		},
		methods: {
			...mapActions('floatingCenters', {
				getCentersByAccountIdAndItsParents: 'getCentersByAccountIdAndItsParents',
				getCentersByCenterLevel: 'getCentersByCenterLevel'
			}),
			findAccountsByAutoKey(keys) {
				let accounts = []
				if (!keys)
					return accounts

				for (let key of keys) {
					accounts.push(...this.getAutoAccountsItemsByKey(key))
				}

				accounts = accounts.reduce((list, current) => {
					if (list.findIndex(x => x.id === current.id) === -1) {
						list.push(current)
					}

					return list
				}, [])

				return accounts.map(x => x.id)
			},
			prepareCentersList() {
				this.setComponentSettings()
				if (this.serverSideStatus) return

				if (this.settings.formName && this.baseAccountsArray.length === 0)
					this.centersList = []
				else if (this.baseAccountsArray.length > 0) {
					let promiseList = []
					if (this.getAllAccounts.filter(x => x.level >= 3 || x.hasChild === false).length === this.baseAccountsArray.length) {
						this.centersList = this.getAllCenters.filter(x => (x.level >= 3 || x.hasChild === false) && x.relatedAccountIds.some(rId => this.baseAccountsArray.some(bId => bId === rId)) && (!this.settings.centerLevel || (x.relatedAccountsByLevel.some(y => this.baseAccountsArray.some(bId => bId === y.accountId) && y.centerLevel === this.settings.centerLevel))))
					} else {
						for (let id of this.baseAccountsArray) {
							promiseList.push(this.getCentersByAccountIdAndItsParents({ accountId: id, centerLevel: this.settings.centerLevel }))
						}
						Promise.all(promiseList)
							.then(values => {
								let list = []
								for (let arr of values) {
									for (let item of arr) {
										if (list.findIndex(x => x.id === item.id) === -1 && item.hasChild === false) {
											list.push(item)
										}
									}
								}

								this.centersList = list
							})
					}
				} else {
					this.getCentersByCenterLevel(this.settings.centerLevel).then(centers => {
						this.centersList = centers
					})
				}
			},
			cleanValue() {
				if (this.modelValue && this.modelValue.length > 0) {
					let cleanedValue = this.modelValue.filter(v => this.centersList.filter(x => x.id === v.id).length > 0)
					if (this.modelValue.length !== cleanedValue.length) {
						this.$emit('update:modelValue', cleanedValue)
					}
				}
			},
			valueChanged(val) {
				this.$emit('update:modelValue', val)
			},
			findExactMatch(list, text) {
				var filtered = list.filter(x => x.accountingCode === text)
				if (filtered.length === 1) {
					return filtered[0]
				}
			},
			showCenterList() {
				this.showModal({
					component: CenterList,
					data: this.dropdownData,
					options: {
						multiSelection: true,
						filterType: 'custom', selected: this.selecteds,
						serverSideStatus: this.serverSideStatus,
						centerLevel: this.settings.centerLevel,
						baseAccountIds: this.baseAccountsArray
					}
				})
					.then((res) => {
						this.$refs.multichoice.refocusDropdown()

						this.selecteds = res
						this.$refs.multichoice.setMergeItems()

						this.valueChanged(res)

					})
					.catch(err => {
						this.$refs.multichoice.refocusDropdown()
					})
			},
			getSelectedItemsText() {
				return this.$refs.multichoice.getSelectedItemsText()
			},
			setComponentSettings() {
				this.settings.dropdown = {
					url: null,
					selectorWidth: 620,
					selectorHeight: '50%',
					buttons: [
						{
							title: this.$t('list'),
							shortcut: $sc.find('enter'),
							isPrimary: true,
							element: () => { return this.$el },
							icon: 'list-ul',
							handle: (button, page, e) => {
								this.showCenterList(true)
							}
						}
					],
					component: {
						type: 'ag-grid',
						options: {
							id: this.$options.name,
							watchForSelectedChanges: true,
							paginationPageSize: 50,
							rowSelection: {
								mode: 'multiRow',
								checkboxes: true,
								headerCheckbox: true
							},
							rowModelType: this.serverSideStatus ? 'serverSide' : 'clientSide',
							serverInfo: {
								api: {
									url: Endpoints.getUrl('floatingCenters.pageList'),
									manipulateResponse: (res) => {
										return {
											rowData: res.data.items,
											rowCount: res.data.totalCount
										}
									}
								},
								finally: () => {
								},
								searchableFields: this.settings.filter?.searchableFields ? this.settings.filter?.searchableFields : [this.serverSideMetadata('Center_Mobile'), this.serverSideMetadata('Center_NationalCode'),],
								payload: {
									baseAccountIds: this.baseAccountsArray.length ? this.baseAccountsArray : null,
									centerLevel: this.settings.centerLevel,
									leaf: true,
									filter: {
										SchemaValues: [],
										...this.settings.filter.serverSide,
									}
								}
							},
							columnDefs: [
								{
									field: 'accountingCode',
									headerName: this.$t('center.selector.table.c.accountingCode'),
									width: 30,
								},
								{
									field: 'name',
									headerName: this.$t('center.selector.table.c.name'),
									sortable: false,
									cellRenderer: FloatingCenterAdvanceName,
									cellRendererParams: (params) => {
										if (params.data) return {
											options: {
												advance: true,
												data: params.data,
												factorType: this.factorType,
											}
										}
									},
									width: 200,
								},
								{
									field: 'parentName',
									headerName: this.$t('center.selector.table.c.parent'),
									sortable: false,
									width: 150,
									contentType: 'enum',
									valueFormatter: params => {
										return params.data.parent?.name ? params.data.parent.name : null
									}
								},
							],
							cellSelectionAggReport: false,
							sideBar: 'none',
							enterToSelect: false,
							doubleClickedToSelect: false,
							checkSelectedOnModelValueChange: true
						},
					},
					remoteSearch: false,
					loadOnMount: false,
					searchableFields: ['accountingCode', 'name'],
					placeholder: this.$t('search'),
					findExactMatch: this.findExactMatch
				}
			},
			serverSideMetadata(metDataField) {
				return (value) => { return { systemField: metDataField, value: value } }
			}
		},
	}
</script>
